<button
  #overlayTrigger="cdkOverlayOrigin"
  cdkOverlayOrigin
  class="user-overlay-select-btn"
  type="button"
  [ariaLabel]="dictionary.overlayTriggerButtonAriaLabel"
  (click)="profileOverlay.toggle()"
>
  @if (isLoading()) {
    <at-skeleton />
  } @else {
    <at-avatar [name]="username()" />
  }
</button>

<at-overlay #profileOverlay scrollStrategy="close" [trigger]="overlayTrigger">
  <app-user-profile-overlay
    [email]="email()"
    [isUserLoading]="isLoading()"
    [username]="username()"
    (close)="profileOverlay.close()"
    (logout)="onLogout()"
  />
</at-overlay>
